import type { InputValues, SupportMessages } from "~/types/Pellets";
import { isValidGermanZipCode } from "./zipCode";

export interface ValidateZipAndAmountOptions {
  minAmount: number;
  maxAmount: number;
  amountLabel?: string;
}

export function validateZipAndAmount(
  inputs: InputValues,
  support: SupportMessages,
  opts: ValidateZipAndAmountOptions,
): boolean {
  const label = opts.amountLabel ?? "kg";
  let isValid = true;

  if (!isValidGermanZipCode(inputs.zipCode)) {
    support.zipCode = "Ungültige Postleitzahl";
    isValid = false;
  } else {
    support.zipCode = "";
  }

  const amount = Number(inputs.amount);
  if (!inputs.amount || amount < opts.minAmount) {
    support.amount = `Minimum ${opts.minAmount.toLocaleString("de-DE")} ${label}`;
    isValid = false;
  } else if (amount > opts.maxAmount) {
    support.amount = `Maximum ${opts.maxAmount.toLocaleString("de-DE")} ${label}`;
    isValid = false;
  } else {
    support.amount = "";
  }

  return isValid;
}
